import { useContext, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { ScrollSpyContext } from "./context";

const useScrollSpy = (id: string): ((node?: Element | null) => void) => {
	const scrollSpyContext = useContext(ScrollSpyContext);

	const { ref, inView } = useInView({ rootMargin: "0px 0px 0px 0px " });

	useEffect(() => {
		scrollSpyContext.register(id);

		return () => {
			scrollSpyContext.unRegister(id);
		};
	}, [id, scrollSpyContext]);

	useEffect(() => {
		scrollSpyContext.setInView(id, inView);
	}, [id, inView, scrollSpyContext]);

	return ref;
};

export default useScrollSpy;
